import React, { useState, useEffect } from 'react';
import Loading from '../Loading'
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import { numberFormat } from '../Investor'




function DataFeedMobile(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus: Invest with the best";
    const [pageData, setpageData] = useState({});
    const axiosPrivate = useAxiosPrivate();
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/data-feed?days=15&access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        setpageData(cdresponse.data)
    }
    const getUrl = (url) => {
        return "/Company/" + url
    }


    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }



    useEffect(() => {
        companyDetails()
    }, [])


    return (
        <div className="HomeMobile" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "11px", minHeight: "650px", paddingLeft: "5px", paddingRight: "5px", paddingBottom: "110px", paddingTop: "10px" }}>

            <div>
                {Object.keys(pageData).length > 0 && 
                    <div style={{ padding: "10px 0px", whitespace: "nowrap" }}>
                    <div className="AboutHeaderTop" style={{ paddingLeft: "0px", paddingTop: "0px" }}>
                        <div className="SuperHeader" style={{ textAlign: "left", padding: "10px 5px", fontSize: "11px", fontWeight: "600" }}>
                            Shareholding pattern filed by companies in the last 15 days.
                        </div>
                    </div>
                        <div style={{ overflowX: "auto", backgroundColor: "white", borderRadius: "10px" }}>
                            
                            <table className="PeersTable finData SupInvestorMobile" style={{ overflowX: "auto", fontSize: "9px", padding: "0px", whitespace: "nowrap" }}>
                                <tbody>
                                    <tr>
                                    <td className="columnHeading" style={{ textAlign: "left", fontWeight: "600", paddingLeft: "5px" }}>Company Name</td>
                                    <td className="columnHeading" style={{ textAlign: "center", fontWeight: "600", padding: "0px" }}>Symbol</td>
                                    <td className="columnHeading" style={{ textAlign: "center", fontWeight: "600", padding: "0px" }}>Quarter</td>
                                    <td className="columnHeading" style={{ textAlign: "center", paddingLeft: "10px", fontWeight: "600", padding: "0px" }}>Broadcast Date</td>
                                    </tr>
                                </tbody>
                                <tbody>
                                {pageData.data.map((dataKey, index) => (
                                        <tr>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{textAlign: "left", minWidth: "0px", padding: "3px 10px", whiteSpace: "nowrap" }}>{dataKey.company_name}</td>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", textAlign: "center", minWidth: "0px", padding: "3px 10px", whiteSpace: "nowrap" }}><a href={getUrl(dataKey.stock_symbol)} target="_blank" style={{ textDecoration: "none" }}>{dataKey.stock_symbol}</a></td>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", textAlign: "center", minWidth: "0px", padding: "3px 5px 3px 0px", whiteSpace: "nowrap" }}>{dataKey.quarter}</td>
                                            <td className={index % 2 === 0 ? "tabledata SubHeader OddDiv" : "tabledata SubHeader"} style={{ maxWidth: "100%", textAlign: "center", minWidth: "0px", padding: "3px 5px 3px 0px", whiteSpace: "nowrap" }}>{dataKey.broadcast_date_str}</td>
                                            
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>

                }
                {Object.keys(pageData).length === 0 &&
                    <div style={{ minHeight: "400px", paddingTop: "180px" }}>
                        <Loading />
                    </div>
                }

            </div>
        </div>
    );
}
export default DataFeedMobile;

